/**
 * @desc 获取用户历史任务
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<
  defs.activiti.PageInfo<defs.activiti.BusinessTaskResponseDto>
>;
export function request(
  params: API.activiti.business.getHistoryTaskListPage.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/business/historyTask`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
